var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsContactUsMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3166 0.818359H1.50177C1.32399 0.818359 1.20548 0.877619 1.08696 0.996137C0.968439 1.11466 0.90918 1.23317 0.90918 1.41095V2.89243C1.73881 3.60354 3.51659 5.02577 6.30177 7.21836L6.59807 7.51466C7.07214 7.92947 7.4277 8.22577 7.72399 8.34429C8.19807 8.64058 8.55362 8.81836 8.84992 8.81836C9.14622 8.81836 9.56103 8.64058 9.97585 8.34429C10.2129 8.16651 10.6277 7.87021 11.1018 7.51466L11.4573 7.21836C14.1833 5.02577 16.0203 3.60354 16.8499 2.89243V1.41095C16.8499 1.23317 16.7907 1.11466 16.6721 0.996137C16.6129 0.877619 16.4944 0.818359 16.3166 0.818359Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.872 8.34421C11.2794 8.81828 10.8646 9.17383 10.5091 9.35161C9.91647 9.70717 9.38313 9.88495 8.90906 9.88495C8.43498 9.88495 7.90165 9.70717 7.30906 9.35161C6.9535 9.11458 6.47943 8.81828 5.94609 8.34421L5.59054 8.04791C3.33869 6.21087 1.73869 4.96643 0.909058 4.31458V11.6035C0.909058 11.7812 0.968317 11.8998 1.08684 12.0183C1.20535 12.1368 1.32387 12.1961 1.50165 12.1961H16.3165C16.4942 12.1961 16.6128 12.1368 16.7313 12.0183C16.8498 11.8998 16.9091 11.7812 16.9091 11.6035V4.31458C16.0794 4.96643 14.5387 6.21087 12.2276 8.04791L11.872 8.34421Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsContactUsMail);
export default __webpack_public_path__ + "static/media/icons_ContactUsMail.f350ea025dd2b200b951f3b31ec376ec.svg";
export { ForwardRef as ReactComponent };